/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createBookmark = /* GraphQL */ `
  mutation CreateBookmark(
    $input: CreateBookmarkInput!
    $condition: ModelBookmarkConditionInput
  ) {
    createBookmark(input: $input, condition: $condition) {
      id
      description
      viewState {
        center
        zoom
        __typename
      }
      layers {
        layerId
        layerTitle
        assetType
        assetUrl
        rasterOpacity
        circleColor
        circleRadius
        fillOpacity
        colormap
        visibility
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateBookmark = /* GraphQL */ `
  mutation UpdateBookmark(
    $input: UpdateBookmarkInput!
    $condition: ModelBookmarkConditionInput
  ) {
    updateBookmark(input: $input, condition: $condition) {
      id
      description
      viewState {
        center
        zoom
        __typename
      }
      layers {
        layerId
        layerTitle
        assetType
        assetUrl
        rasterOpacity
        circleColor
        circleRadius
        fillOpacity
        colormap
        visibility
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteBookmark = /* GraphQL */ `
  mutation DeleteBookmark(
    $input: DeleteBookmarkInput!
    $condition: ModelBookmarkConditionInput
  ) {
    deleteBookmark(input: $input, condition: $condition) {
      id
      description
      viewState {
        center
        zoom
        __typename
      }
      layers {
        layerId
        layerTitle
        assetType
        assetUrl
        rasterOpacity
        circleColor
        circleRadius
        fillOpacity
        colormap
        visibility
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
